export const changeMonitoringLevel2Reducer = (state = "", action) => {
  switch (action.type) {
    case "CHANGE_MonitoringLevel2":
      return action.payload.MonitoringLevel2;
    default:
      return state;
  }
};
